import React from 'react';

import { Box, H1, Text } from '@betterment/samba-react';

import { Header } from './Header';
import PackageNotFoundError from './PackageNotFoundError';

import Docusign from '../../AdvisedSignup401kAgreementSignature/components/Docusign';

export const SignDocument: React.FC<{ logoUrl?: string }> = ({ logoUrl }) => {
  const handleContinue = () => {
    // TODO: Wire up to actual flow navigation
    // eslint-disable-next-line no-console
    console.log('Continue clicked');
  };

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Header logoUrl={logoUrl} progress={99} title="Plan document" />
      <Box
        css={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'center',
          padding: 'space.400',
          paddingTop: 'space.800',
          width: '672px',
        }}
      >
        <Box css={{ pb: 'space.800' }}>
          <H1
            variant="pageTitle"
            css={{
              marginBottom: 'space.150',
              color: 'text.DEFAULT',
              paddingBottom: 'space.200',
            }}
          >
            Review and sign your solo 401(k) plan adoption and trust agreements
          </H1>
          <Text
            as="p"
            css={{
              fontSize: 'fontSize.100',
              color: 'text.DEFAULT',
              lineHeight: 'lineHeights.normal',
              textAlign: 'start',
              paddingBottom: 'space.400',
            }}
          >
            Please review and sign the solo 401(k) adoption and trust agreements, which are required to open your solo
            401(k) plans (Traditional + Roth). Additionally, consider reviewing the plan document, QDRO, and IRS opinion
            letter for additional information.
          </Text>

          <PackageNotFoundError />

          <Docusign onSessionEnd={handleContinue} docusignClientId="todo" docusignSignatureURL="todo" />
        </Box>
      </Box>
    </Box>
  );
};
